import React from 'react';
import { motion } from 'framer-motion';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useLiveViewers } from '../../hooks/useLiveViewers';
import { purchaseActivity, activityToneStyles } from '../../data/liveActivity';
export function LiveActivityPanel() {
  const viewers = useLiveViewers();
  const feed = [...purchaseActivity, ...purchaseActivity];
  return <aside className="relative flex h-[440px] w-full flex-col overflow-hidden rounded-[26px] border border-white/15 bg-brand-deep/60 p-5 shadow-brand-lg backdrop-blur-md xl:h-full xl:w-[360px] xl:flex-shrink-0" data-id="element-138" data-mp="tv8q2i1go0xs">
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[26px] bg-[radial-gradient(circle_at_85%_0%,rgba(34,197,94,0.16),transparent_55%)]" data-id="element-139" data-mp="12pf09ew41ag9" />

      <p className="relative mb-3 text-[10.5px] font-bold uppercase tracking-[0.25em] text-white/55" data-id="element-140" data-mp="a4wyixcvkpgw">
        Actividad en vivo
      </p>

      <div className="relative mb-4 flex animate-float items-center gap-3 rounded-[18px] border border-brand-green/40 bg-white/[0.06] px-4 py-3.5" data-id="element-141" data-mp="2vchcyixnbhql">
        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-brand-green/15 text-brand-green" data-id="element-142" data-mp="3097rv2xps7af">
          <VisibilityIcon style={{
          fontSize: 18
        }} data-id="element-143" data-mp="3a0u6zad6aqig" />
        </span>
        <div data-id="element-144" data-mp="3a02bs0nhmusp">
          <p className="flex items-center gap-2 font-display text-xl font-extrabold leading-none text-white" data-id="element-145" data-mp="3a2ok42i7debz">
            <span className="relative flex h-2 w-2" data-id="element-146" data-mp="2hc6jd84ybp1q">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-green opacity-75" data-id="element-147" data-mp="2hcy6dukhgege" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-green" data-id="element-148" data-mp="2mdcd99aclicu" />
            </span>
            {viewers}
          </p>
          <p className="mt-1 text-[11px] text-white/70" data-id="element-149" data-mp="1lk1dsa2r35x">
            personas viendo esta página ahora
          </p>
        </div>
      </div>

      <p className="relative mb-2.5 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.1em] text-white/60" data-id="element-150" data-mp="6ik907mkodz5">
        <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-brand-yellow" data-id="element-151" data-mp="22p31ms6m0xf1" />
        Compras recientes
      </p>

      <div className="relative flex-1 overflow-hidden [mask-image:linear-gradient(to_bottom,transparent_0,#000_8%,#000_90%,transparent_100%)]" data-id="element-152" data-mp="2bnohugom00cn">
        <motion.ul className="absolute inset-x-0 top-0" animate={{
        y: ['0%', '-50%']
      }} transition={{
        duration: 34,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-153" data-mp="27mup9a081xdf">
          {feed.map((item, index) => {
          const tone = activityToneStyles[item.tone];
          return <li key={`${item.id}-${index}`} className="mb-2.5 flex items-center gap-3 rounded-2xl bg-white px-3 py-2.5 text-ink shadow-card" data-id="element-154" data-mp="1sqdiyx6w38xq" data-mpi={index}>
                <span className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full font-display text-[11px] font-extrabold ${tone.avatar}`} data-id="element-155" data-mp="106yfj8nb3sob">
                  {item.initials}
                </span>
                <p className="text-[11.5px] leading-snug" data-id="element-156" data-mp="quhiugfbsh6v">
                  <span className="font-bold text-brand-blue" data-id="element-157" data-mp="qw2de61n404q">{item.name}</span>
                  <span className="text-muted" data-id="element-158" data-mp="c6mokvlo64ro"> · {item.location}</span>
                  <br data-id="element-159" data-mp="h3czz5mj4c6r" />
                  acaba de contratar el{' '}
                  <span className={`font-bold ${tone.pkg}`} data-id="element-160" data-mp="14tqur3wi0p51">
                    {item.packageName}
                  </span>
                  <br data-id="element-161" data-mp="19t3l3ymkwecd" />
                  <span className="text-[10px] text-muted" data-id="element-162" data-mp="19sbmeexoq0hv">{item.timeAgo}</span>
                </p>
                <CheckCircleIcon style={{
              fontSize: 18
            }} className="ml-auto flex-shrink-0 text-brand-green" data-id="element-163" data-mp="uv1dndcff8pu" />
              </li>;
        })}
        </motion.ul>
      </div>
    </aside>;
}